(function() {
	PM.ApiIntegration = {};

	PM.ApiIntegration.renderSection = function() {
		if (!PM.Shell.checkFeature('api_keys')) {
			PM.ApiIntegration._renderUpgrade();
			return;
		}
		$.when(
			$.get('/api/integrations/api'),
			$.get('/api/roles/functions'),
			ejs.preloadTemplate('/app/config/integrations/api/templates/api-keys.ejs'),
			ejs.preloadTemplate('/app/config/integrations/api/templates/api-key-modal.ejs'),
			ejs.preloadTemplate('/app/config/integrations/api/templates/api-key-reveal.ejs')
		).done(function(keysResult, funcsResult) {
			var keys = keysResult[0];
			var functions = funcsResult[0];
			var html = ejs.rr('/app/config/integrations/api/templates/api-keys.ejs', {
				keys: keys,
				functions: functions
			});
			PM.Config.renderSection('integrations/api', html);
		});
	};

	$(document).on('click', '.js-api-key-add', function() {
		$.get('/api/roles/functions').done(function(functions) {
			var modalHtml = ejs.rr('/app/config/integrations/api/templates/api-key-modal.ejs', {
				functions: functions
			});
			var $modal = $(modalHtml);
			$('body').append($modal);
			var bsModal = new bootstrap.Modal($modal[0]);
			bsModal.show();

			$modal.on('hidden.bs.modal', function() {
				$modal.remove();
			});
		});
	});

	$(document).on('click', '.js-api-key-create', function() {
		var $modal = $(this).closest('.js-api-key-modal');
		var name = $modal.find('.js-api-key-name').val().trim();
		var permIds = [];
		$modal.find('.js-api-key-permission:checked').each(function() {
			permIds.push(parseInt($(this).val(), 10));
		});

		if (!name) {
			new Notify({ status: 'error', text: 'Name is required.', timeout: 3000 });
			return;
		}
		if (permIds.length === 0) {
			new Notify({ status: 'error', text: 'At least one permission is required.', timeout: 3000 });
			return;
		}

		var $btn = $(this);
		$btn.prop('disabled', true).text('Generating...');

		$.ajax({
			url: '/api/integrations/api',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({ name: name, permission_ids: permIds })
		}).done(function(data) {
			$modal.find('.modal-title').text('API key generated');
			$modal.find('.modal-body').html(
				ejs.rr('/app/config/integrations/api/templates/api-key-reveal.ejs', { key: data.key })
			);
			$modal.find('.modal-footer').html('<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>');

			$modal.on('hidden.bs.modal', function() {
				PM.ApiIntegration.renderSection();
			});

			new Notify({ status: 'success', text: 'API key created.', timeout: 3000 });
		}).always(function() {
			$btn.prop('disabled', false).text('Generate');
		});
	});

	$(document).on('click', '.js-copy-api-key', function() {
		$('.js-api-key-value').select();
		document.execCommand('copy');
		new Notify({ status: 'success', text: 'Copied.', timeout: 2000 });
	});

	$(document).on('click', '.js-api-key-revoke', function() {
		var id = $(this).data('key-id');
		var name = $(this).data('key-name');
		if (!confirm('Revoke the API key "' + name + '"? This cannot be undone.')) return;

		$.ajax({
			url: '/api/integrations/api/' + id,
			method: 'DELETE'
		}).done(function() {
			new Notify({ status: 'success', text: 'API key revoked.', timeout: 3000 });
			PM.ApiIntegration.renderSection();
		});
	});

	PM.ApiIntegration._renderUpgrade = function() {
		ejs.preloadTemplate('/app/shell/templates/upgrade-required.ejs').then(function() {
			var html = ejs.rr('/app/shell/templates/upgrade-required.ejs', {});
			PM.Config.renderSection('integrations/api', html);
		});
	};
})();
